/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { ActiveState, Jsonld, SeoProps } from "@eisinc/App/Widgets/SearchEngineOptimization/SearchEngineOptimization";

/**
 * Activate structure based on condition
 *
 * @param SeoProps
 * @returns ActiveState
 */
const activate = ({ state }: SeoProps): ActiveState => {
    return state?.components?.breadcrumbs?.links?.length;
};

/**
 * Build the structured data
 *
 * @param SeoProps
 * @returns Jsonld
 */
const json = ({ state }: SeoProps): Jsonld => {
    const url = state?.context?.website?.uri?.split("/")?.splice(0, 3)?.join("/");

    const itemListElement = state?.components?.breadcrumbs?.links?.map((item, index) => {
        const itemHref = item.href ? `${url}${item.href}` : url;
        const itemName: string = typeof item.children === "string" ? item.children : "";
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@id": itemHref,
                name: itemName,
            },
        };
    });

    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: itemListElement as Jsonld[] | undefined,
    };
};

export default { activate, json };
